exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-history-1{fill:#fff}.content-history-2{fill:#72cac2}.content-history-3{fill:#fbe57f}.content-history-4{fill:#1e4e69}\n", ""]);
